import React, { Component, useEffect, useState } from 'react';
import { Select, Input, Button, Popconfirm, Tag, Row, Col, notification, Space, Tooltip, Form, message, Switch } from 'antd';
import {
    CopyOutlined,
    MoreOutlined,
    ClockCircleOutlined,
    CheckCircleOutlined,
    LoadingOutlined,
    CheckCircleTwoTone,
    CheckOutlined,
    CloseOutlined,
    WarningTwoTone,
    WarningOutlined,
    EyeTwoTone,
    DeleteOutlined,
    PlusCircleOutlined,
} from '@ant-design/icons';
import Popconfirm_comments from '../../commonComponents/Popconfirm_Comments';
import FilterAutoComplete from '../../commonComponents/FilterAutoComplete';
import PaginatedTable from '../../commonComponents/PaginatedTable';
import { useGetCompanyListMinimal } from '../../hooks/useCompanies';
import { useGetOrderListMinimal } from '../../hooks/useOrders';
import {
    useSearchSku,
    useRerunSkuFromRawQC,
    useRerunSkuFromShoot,
    useGetCategoriesForReshoot,
    useAddCategoryToList,
    useMarkAsSupportSku,
    useClientRequest,
    useResetForProductionRequest,
    useDownloadExcelForSku,
    useRaisePresetChangeRequest,
    useRePIIRequest,
    useAddHeroToFundus,
    useChangeSkuOrderRequest,
} from '../../hooks/useSkus';
import SkuDetails from './SkuDetails';
import style from './index.module.css';
import stl from 'string-to-color';
import useLogout from '../../hooks/useLogout';
import DynamicModal from '../../commonComponents/DynamicModal/DynamicModal';
import RaiseRequests from './RaiseRequests';
import PopconfirmFilter from '../../commonComponents/PopConfirmFilter';
import { MAX_SKU_SEARCH_TERMS, parseSkuSearchList } from '../../utils/parseSkuSearchList';

function skuDisplayName(record) {
    return record?.csvData?.EAN || record?.csvData?.barcode || record?.skuName || '';
}

function cmpText(left, right) {
    return String(left ?? '').localeCompare(String(right ?? ''), undefined, { numeric: true, sensitivity: 'base' });
}

function cmpBool(left, right) {
    return Number(Boolean(left)) - Number(Boolean(right));
}

export default function EanDetails() {
    const [api, contextHolder] = notification.useNotification();
    const [selectedCompanies, setSelectedCompanies] = useState('');
    const [selectedOrders, setSelectedOrders] = useState('');
    const [selectedCategoryForReshoot, setSelectedCategoryForReshoot] = useState('');
    const [newCategoryAdded, setNewCategoryAdded] = useState('');
    const [pageNum, setPageNum] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [searchText, setSearchText] = useState('');
    const [isCCRequired, setisCCRequired] = useState(undefined);
    const [isDDApproved, setIsDDApproved] = useState(undefined);
    const [isPendingAtRawQC, setIsPendingAtRawQc] = useState(undefined);
    const [markedAsSupport, setMarkedAsSupport] = useState(undefined);
    const [isOutbound, setIsOutbounded] = useState(undefined);
    const [searchTextDebounce, setSearchTextDebounce] = useState(null);
    const [selectedSku, setSelectedSku] = useState(null);
    const [showSkuDetails, setShowSkuDetails] = useState(false);
    const [wantNewCategoryToAdd, setWantNewCategoryToAdd] = useState(false);
    const [isRaiseRequestClicked, setIsRaiseRequestClicked] = useState(false);
    const [raisedRequestButtonData, setRaisedRequestButtonData] = useState(null);
    const [selelctedRequestType, setSelectedRequestType] = useState('');
    const [requestComment, setRequestComment] = useState('');
    const RerunSkuFromRawQCMutation = useRerunSkuFromRawQC();
    const RerunSkuFromShootMutation = useRerunSkuFromShoot();
    const MarkAsSupportSku = useMarkAsSupportSku();
    const RaiseClientRequest = useClientRequest();
    const RaiseResetForProductionRequest = useResetForProductionRequest();
    const RaisePresetChangeRequest = useRaisePresetChangeRequest();
    const RaiseRePIIRequest = useRePIIRequest();
    const AddHeroToFundus = useAddHeroToFundus();
    const RaiseChangeSkuOrder = useChangeSkuOrderRequest();
    const [targetCompanyCode, setTargetCompanyCode] = useState('');
    const [targetOrderId, setTargetOrderId] = useState('');
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectedRowsById, setSelectedRowsById] = useState({});
    const [bulkRaiseSkus, setBulkRaiseSkus] = useState([]);
    const [isRaisingRequests, setIsRaisingRequests] = useState(false);
    const addNewCategoryUseList = useAddCategoryToList();
    const [selectedAngles, setSelectedAngles] = useState([]);
    const [isPresetChangeReshootRequired, setPresetChangeReshootRequired] = useState(true);
    const [selectedPresetId, setSelectedPresetId] = useState(null);
    const [selectedModel, setSelectedModel] = useState(null);
    const [isAutoApproveDD, setAutoApproveDD] = useState(false);
    const [autoApproveRequest, setAutoApproveRequest] = useState(false);
    const [isSpecialCategory, setIsSpecialCategory] = useState(false);
    const { logout } = useLogout();

    const ClearAllFilters = () => {
        setSearchText('');
        setSelectedCompanies('');
        setSelectedOrders('');
        OnChangePaginator(1, pageSize);
        setisCCRequired(undefined);
        setIsDDApproved(undefined);
        setIsPendingAtRawQc(undefined);
        setMarkedAsSupport(undefined);
        setIsOutbounded(undefined);
        setSelectedRowKeys([]);
        setSelectedRowsById({});
    };

    useEffect(() => {
        const timeout = setTimeout(() => {
            setSearchTextDebounce(searchText);
        }, 1000);
        return () => clearTimeout(timeout);
    }, [searchText]);

    useEffect(() => {
        setSelectedRowKeys([]);
        setSelectedRowsById({});
    }, [
        searchTextDebounce,
        selectedCompanies,
        selectedOrders,
        pageSize,
        isCCRequired,
        isDDApproved,
        isPendingAtRawQC,
        markedAsSupport,
        isOutbound,
        isSpecialCategory,
    ]);

    const OnChangePaginator = (pageNum, pageSize) => {
        setPageNum(pageNum);
        setPageSize(pageSize);
    };

    const { data: companies, isFetching: isFetchingcompanies, isFetched: isFetchedcompanies, refetch: refetchcompanies } = useGetCompanyListMinimal();
    const {
        data: ordersList,
        isFetching: isFetchingOrders,
        isFetched: isFetchedOrders,
        refetch: refetchOrders,
    } = useGetOrderListMinimal(selectedCompanies);
    const {
        data: categoriesList,
        isFetching: isFetchingCategories,
        isFetched: isFetchedCategories,
        refetch: refetchCategories,
    } = useGetCategoriesForReshoot(selectedCompanies);

    const {
        data: skuList,
        isFetched: isFetchedSkus,
        isFetching: isFetchingSkus,
        refetch: refetchSkuList,
    } = useSearchSku(
        selectedCompanies,
        selectedOrders,
        searchTextDebounce,
        pageNum,
        pageSize,
        isCCRequired,
        isDDApproved,
        isPendingAtRawQC,
        markedAsSupport,
        isOutbound,
        isSpecialCategory
    );

    const onSuccess = response => {
        console.log('first', response);
        var blob = new Blob([response.data], {
            type: response.headers['content-type'],
        });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        let filename = response.headers['content-disposition'].split('filename=')[1].split('.')[0];
        link.setAttribute('download', `${filename}.xlsx`);
        document.body.appendChild(link);
        link.click();
    };

    const onError = err => {
        if (err?.status?.response === 401) {
            logout();
        }
        message.error(err?.response?.data?.message | 'Error!');
        refetchSkuList();
    };

    const { mutate: downloadExcelFileSkus } = useDownloadExcelForSku(onSuccess, onError);

    const downloadExcelFile = () => {
        const filterParams = {
            companyCode: selectedCompanies,
            orderId: selectedOrders,
            searchText: searchTextDebounce,
            pageNum,
            pageSize,
            isCCRequired,
            isDDApproved,
            isPendingAtRawQC,
            markedAsSupport,
            isOutbound,
        };

        if (isSpecialCategory) {
            filterParams.isSpecialCategory = isSpecialCategory;
        }

        downloadExcelFileSkus(filterParams);
    };

    const approvalDescription = result =>
        result?.autoApproved ? 'Approved automatically. No mail was sent.' : 'Please contact the appropriate person for approval.';

    const HandleRerunSkuFromRawQC = (skuId, comment) => {
        console.log('HandleRerunSkuFromRawQC', { skuId, comment, selectedCategoryForReshoot });
        RerunSkuFromRawQCMutation.mutateAsync([skuId, comment, selectedCategoryForReshoot, autoApproveRequest])
            .then(result => {
                api.success({
                    message: 'Successfuly raised Sku rerun from RawQC request.',
                    description: approvalDescription(result),
                });

                setIsRaiseRequestClicked(false);
                setRaisedRequestButtonData(null);
                setSelectedRequestType('');
                setSelectedCategoryForReshoot('');
                setWantNewCategoryToAdd(false);
                setNewCategoryAdded('');
                setRequestComment('');
                setPresetChangeReshootRequired(true);
            })
            .catch(error => {
                console.log(error);
                api.error({
                    message: 'Failed to raise request',
                    description: JSON.parse(error?.response?.data)?.message || error?.message,
                });
                setWantNewCategoryToAdd(false);
                setNewCategoryAdded('');
                if (error?.response?.status === 401) logout();
            })
            .finally(() => {
                refetchSkuList();
            });
    };

    const HandleMarkAsSupportSku = (skuId, comment) => {
        console.log('HandleMarkAsSupportSku', { skuId, comment, selectedCategoryForReshoot });
        MarkAsSupportSku.mutateAsync([skuId, comment, autoApproveRequest])
            .then(result => {
                api.success({
                    message: 'Successfuly raised Mark Sku as Support request.',
                    description: approvalDescription(result),
                });

                setIsRaiseRequestClicked(false);
                setRaisedRequestButtonData(null);
                setSelectedRequestType('');
                setSelectedCategoryForReshoot('');
                setWantNewCategoryToAdd(false);
                setNewCategoryAdded('');
                setRequestComment('');
                setPresetChangeReshootRequired(true);
            })
            .catch(error => {
                console.log(error);
                api.error({
                    message: 'Failed to raise request',
                    description: JSON.parse(error?.response?.data)?.message || error?.message,
                });
                setWantNewCategoryToAdd(false);
                setNewCategoryAdded('');
                if (error?.response?.status === 401) logout();
            })
            .finally(() => {
                refetchSkuList();
            });
    };

    const getReshootCategoriesOption = () => {
        let categoriesArray = [];
        if (categoriesList?.categories) {
            categoriesList?.categories?.forEach(element => {
                categoriesArray.push({
                    label: element,
                    value: element,
                });
            });
        }
        return categoriesArray;
    };
    const HandleRerunSkuFromShoot = (skuId, comment) => {
        console.log('HandleRerunSkuFromShoot', { skuId, comment, selectedCategoryForReshoot });
        setSelectedCategoryForReshoot('');
        RerunSkuFromShootMutation.mutateAsync([skuId, comment, selectedCategoryForReshoot, selectedAngles, autoApproveRequest])
            .then(result => {
                api.success({
                    message: 'Successfuly raised Sku rerun from Shoot request.',
                    description: approvalDescription(result),
                });
                setIsRaiseRequestClicked(false);
                setRaisedRequestButtonData(null);
                setSelectedRequestType('');
                setSelectedCategoryForReshoot('');
                setWantNewCategoryToAdd(false);
                setNewCategoryAdded('');
                setRequestComment('');
                setSelectedAngles([]);
                setPresetChangeReshootRequired(true);
            })
            .catch(error => {
                api.error({
                    message: 'Failed to raise request',
                    description: JSON.parse(error?.response?.data)?.message || error?.message,
                });
                setWantNewCategoryToAdd(false);
                setNewCategoryAdded('');
                if (error?.response?.status === 401) logout();
            })
            .finally(() => {
                refetchSkuList();
            });
    };
    const handleClientRequest = (skuId, comment) => {
        RaiseClientRequest.mutateAsync([skuId, comment, autoApproveRequest])
            .then(result => {
                api.success({
                    message: 'Successfuly raised Client Clarification request.',
                    description: approvalDescription(result),
                });

                setIsRaiseRequestClicked(false);
                setRaisedRequestButtonData(null);
                setSelectedRequestType('');
                setSelectedCategoryForReshoot('');
                setWantNewCategoryToAdd(false);
                setNewCategoryAdded('');
                setRequestComment('');
                setPresetChangeReshootRequired(true);
            })
            .catch(error => {
                console.log(error);
                api.error({
                    message: 'Failed to raise request',
                    description: JSON.parse(error?.response?.data)?.message || error?.message,
                });
                setWantNewCategoryToAdd(false);
                setNewCategoryAdded('');
                if (error?.response?.status === 401) logout();
            })
            .finally(() => {
                refetchSkuList();
            });
    };

    const handleResendProductionRequest = (skuId, comment) => {
        RaiseResetForProductionRequest.mutateAsync([skuId, comment, autoApproveRequest])
            .then(result => {
                api.success({
                    message: 'Successfuly raised Resend to Production Request',
                    description: approvalDescription(result),
                });

                setIsRaiseRequestClicked(false);
                setRaisedRequestButtonData(null);
                setSelectedRequestType('');
                setSelectedCategoryForReshoot('');
                setWantNewCategoryToAdd(false);
                setNewCategoryAdded('');
                setRequestComment('');
                setPresetChangeReshootRequired(true);
            })
            .catch(error => {
                console.log(error);
                api.error({
                    message: 'Failed to raise request',
                    description: JSON.parse(error?.response?.data)?.message || error?.message,
                });
                setWantNewCategoryToAdd(false);
                setNewCategoryAdded('');
                if (error?.response?.status === 401) logout();
            })
            .finally(() => {
                refetchSkuList();
            });
    };

    const selectedModelPayload = selectedModel
        ? { modelId: selectedModel.modelId, occassion: selectedModel.occassion }
        : null;

    const handlePresetChangeRequest = (skuId, comment, reshootRequired) => {
        RaisePresetChangeRequest.mutateAsync([
            skuId,
            comment,
            reshootRequired,
            selectedPresetId,
            selectedModelPayload,
            isAutoApproveDD,
            autoApproveRequest,
        ])
            .then(result => {
                api.success({
                    message: 'Successfuly raised Preset Change request.',
                    description: approvalDescription(result),
                });

                setIsRaiseRequestClicked(false);
                setRaisedRequestButtonData(null);
                setSelectedRequestType('');
                setSelectedCategoryForReshoot('');
                setWantNewCategoryToAdd(false);
                setNewCategoryAdded('');
                setRequestComment('');
                setPresetChangeReshootRequired(true);
                setSelectedPresetId(null);
                setSelectedModel(null);
                setAutoApproveDD(false);
            })
            .catch(error => {
                console.log(error);
                api.error({
                    message: 'Failed to raise request',
                    description: JSON.parse(error?.response?.data)?.message || error?.message,
                });
                setWantNewCategoryToAdd(false);
                setNewCategoryAdded('');
                if (error?.response?.status === 401) logout();
            })
            .finally(() => {
                refetchSkuList();
            });
    };

    const skuLabel = sku => sku?.csvData?.EAN || sku?.csvData?.barcode || sku?.skuName || sku?._id;

    const resetRaiseForm = () => {
        setIsRaiseRequestClicked(false);
        setRaisedRequestButtonData(null);
        setBulkRaiseSkus([]);
        setSelectedRequestType('');
        setSelectedCategoryForReshoot('');
        setWantNewCategoryToAdd(false);
        setNewCategoryAdded('');
        setRequestComment('');
        setPresetChangeReshootRequired(true);
        setSelectedPresetId(null);
        setSelectedModel(null);
        setAutoApproveDD(false);
        setAutoApproveRequest(false);
        setSelectedAngles([]);
        setTargetCompanyCode('');
        setTargetOrderId('');
    };

    const raiseOneSku = sku => {
        const skuId = sku?._id;
        switch (selelctedRequestType) {
            case 'Reshoot':
                return RerunSkuFromShootMutation.mutateAsync([skuId, requestComment, selectedCategoryForReshoot, selectedAngles, autoApproveRequest]);
            case 'RawQC Reset':
                return RerunSkuFromRawQCMutation.mutateAsync([skuId, requestComment, selectedCategoryForReshoot, autoApproveRequest]);
            case 'Mark As Support':
                return MarkAsSupportSku.mutateAsync([skuId, requestComment, autoApproveRequest]);
            case 'Client Clarification':
                return RaiseClientRequest.mutateAsync([skuId, requestComment, autoApproveRequest]);
            case 'Resend Sku To Production':
                return RaiseResetForProductionRequest.mutateAsync([skuId, requestComment, autoApproveRequest]);
            case 'Preset Change':
                return RaisePresetChangeRequest.mutateAsync([
                    skuId,
                    requestComment,
                    isPresetChangeReshootRequired,
                    selectedPresetId,
                    selectedModelPayload,
                    isAutoApproveDD,
                    autoApproveRequest,
                ]);
            case 'rePII':
                return RaiseRePIIRequest.mutateAsync([skuId, requestComment, autoApproveRequest]);
            case 'Hero to Fundus':
                return AddHeroToFundus.mutateAsync([skuId, requestComment, autoApproveRequest]);
            case 'Change Order':
                return RaiseChangeSkuOrder.mutateAsync([skuId, targetOrderId, requestComment]);
            default:
                return Promise.reject(new Error('Select a request type'));
        }
    };

    const raiseConfirmRequest = async () => {
        const skus = bulkRaiseSkus.length > 1 ? bulkRaiseSkus : [raisedRequestButtonData].filter(Boolean);
        if (!skus.length) return;

        if (skus.length === 1) {
            const handlers = {
                Reshoot: () => HandleRerunSkuFromShoot(skus[0]._id, requestComment),
                'RawQC Reset': () => HandleRerunSkuFromRawQC(skus[0]._id, requestComment),
                'Mark As Support': () => HandleMarkAsSupportSku(skus[0]._id, requestComment),
                'Client Clarification': () => handleClientRequest(skus[0]._id, requestComment),
                'Resend Sku To Production': () => handleResendProductionRequest(skus[0]._id, requestComment),
                'Preset Change': () => handlePresetChangeRequest(skus[0]._id, requestComment, isPresetChangeReshootRequired),
                rePII: () => handleRePIIRequest(skus[0]._id, requestComment),
                'Hero to Fundus': () => handleAddHeroToFundus(skus[0]._id, requestComment),
                'Change Order': () => handleChangeSkuOrder(skus[0]._id, targetOrderId, requestComment),
            };
            const run = handlers[selelctedRequestType];
            if (run) run();
            return;
        }

        setIsRaisingRequests(true);
        const results = await Promise.allSettled(skus.map(sku => raiseOneSku(sku)));
        setIsRaisingRequests(false);

        const failed = results
            .map((result, index) => {
                if (result.status !== 'rejected') return null;
                const err = result.reason;
                let detail = err?.message || 'Failed';
                try {
                    detail = JSON.parse(err?.response?.data)?.message || detail;
                } catch (e) {
                    detail = err?.response?.data?.message || detail;
                }
                return `${skuLabel(skus[index])}: ${detail}`;
            })
            .filter(Boolean);
        const ok = results.length - failed.length;

        const fulfilled = results.filter(result => result.status === 'fulfilled');
        const allAutoApproved = fulfilled.length > 0 && fulfilled.every(result => result.value?.autoApproved);
        if (failed.length === 0) {
            api.success({
                message: `Raised ${ok} ${selelctedRequestType} request${ok === 1 ? '' : 's'}.`,
                description: allAutoApproved
                    ? 'Approved automatically. No mail was sent.'
                    : 'Please contact the appropriate person for approval.',
            });
        } else {
            api.error({
                message: `${ok} succeeded, ${failed.length} failed`,
                description: failed.slice(0, 8).join(' · '),
            });
        }

        resetRaiseForm();
        setSelectedRowKeys([]);
        setSelectedRowsById({});
        if (results.some(result => result.reason?.response?.status === 401)) logout();
        refetchSkuList();
    };

    const addNewCategoryToList = () => {
        addNewCategoryUseList
            ?.mutateAsync([newCategoryAdded])
            .then(result => {
                api.success({
                    message: 'Successfuly added category to list.',
                });
                setNewCategoryAdded('');
                setWantNewCategoryToAdd(false);
            })
            .catch(error => {
                api.error({
                    message: 'Failed to add category',
                    description: error?.message,
                });
                if (error?.response?.status === 401) logout();
            })
            .finally(() => {
                refetchCategories();
            });
    };

    const handleRePIIRequest = (skuId, comment) => {
        RaiseRePIIRequest.mutateAsync([skuId, comment, autoApproveRequest])
            .then(result => {
                api.success({
                    message: 'Successfully raised rePII request.',
                    description: approvalDescription(result),
                });

                setIsRaiseRequestClicked(false);
                setRaisedRequestButtonData(null);
                setSelectedRequestType('');
                setSelectedCategoryForReshoot('');
                setWantNewCategoryToAdd(false);
                setNewCategoryAdded('');
                setRequestComment('');
                setPresetChangeReshootRequired(true);
            })
            .catch(error => {
                console.log(error);
                api.error({
                    message: 'Failed to raise rePII request',
                    description: JSON.parse(error?.response?.data)?.message || error?.message,
                });
                setWantNewCategoryToAdd(false);
                setNewCategoryAdded('');
                if (error?.response?.status === 401) logout();
            })
            .finally(() => {
                refetchSkuList();
            });
    };

    const handleChangeSkuOrder = (skuId, orderId, comment) => {
        RaiseChangeSkuOrder.mutateAsync([skuId, orderId, comment])
            .then(() => {
                api.success({
                    message: 'Successfully raised Change Order request.',
                    description: 'The SKU is being moved to the selected order.',
                });
                setIsRaiseRequestClicked(false);
                setRaisedRequestButtonData(null);
                setSelectedRequestType('');
                setSelectedCategoryForReshoot('');
                setWantNewCategoryToAdd(false);
                setNewCategoryAdded('');
                setRequestComment('');
                setPresetChangeReshootRequired(true);
                setTargetCompanyCode('');
                setTargetOrderId('');
            })
            .catch(error => {
                api.error({
                    message: 'Failed to raise Change Order request',
                    description: JSON.parse(error?.response?.data)?.message || error?.message,
                });
                if (error?.response?.status === 401) logout();
            })
            .finally(() => {
                refetchSkuList();
            });
    };

    const handleAddHeroToFundus = (skuId, comment) => {
        AddHeroToFundus.mutateAsync([skuId, comment, autoApproveRequest])
            .then(result => {
                api.success({
                    message: 'Successfully Added to fundus.',
                    description: "",
                });

                setIsRaiseRequestClicked(false);
                setRaisedRequestButtonData(null);
                setSelectedRequestType('');
                setSelectedCategoryForReshoot('');
                setWantNewCategoryToAdd(false);
                setNewCategoryAdded('');
                setRequestComment('');
                setPresetChangeReshootRequired(true);
            })
            .catch(error => {
                console.log(error);
                api.error({
                    message: 'Failed to add product to fundus',
                    description: JSON.parse(error?.response?.data)?.message || error?.message,
                });
                setWantNewCategoryToAdd(false);
                setNewCategoryAdded('');
                if (error?.response?.status === 401) logout();
            })
            .finally(() => {
                refetchSkuList();
            });
    };

    const ModalTitle = ({ companyCode, batchName, name, barcodes, description }) => {
        return (
            <Space
                flex="auto"
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                    // border: '1px solid red',
                }}
            >
                <p>Raise Request -</p>
                <p>
                    <Tag>{name}</Tag>
                </p>
            </Space>
        );
    };

    const handleAngleSelection = id => {
        let tempArr = [...selectedAngles];
        let inData = tempArr.findIndex(el => el == id);
        if (inData > -1) {
            tempArr = tempArr.filter(item => item != id);
        } else {
            tempArr.push(id);
        }

        setSelectedAngles(tempArr);
    };
    const handleSelectAllAngles = val => {
        if (val) {
            setSelectedAngles(raisedRequestButtonData?.angles?.map(el => el?._id));
        } else {
            setSelectedAngles([]);
        }
    };

    const getFiltersAppliedCount = () => {
        let count = 0;
        if (isCCRequired !== undefined) {
            ++count;
        }
        if (isDDApproved !== undefined) {
            ++count;
        }
        if (markedAsSupport !== undefined) {
            ++count;
        }
        if (isPendingAtRawQC !== undefined) {
            ++count;
        }
        if (isOutbound !== undefined) {
            ++count;
        }
        return count;
    };
    const handleSpecialCategoryFilter = () => {
        setIsSpecialCategory(!isSpecialCategory);
        setPageNum(1);
    };
    const parsedSearch = parseSkuSearchList(searchText);
    return (
        <>
            {contextHolder}
            <div className="d-flex reshoot-header">
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.5rem',
                        position: 'relative',
                    }}
                >
                    <h5>Client: </h5>
                    <div>
                        <Select
                            loading={isFetchingcompanies}
                            mode="single"
                            style={{
                                minWidth: 300,
                            }}
                            allowClear
                            className={style.select}
                            placeholder={'Select Company'}
                            // onDeselect={onDeselect}
                            // onSelect={onSelect}
                            value={selectedCompanies}
                            dropdownMatchSelectWidth={false}
                            dropdownStyle={{ minWidth: '330px' }}
                            size="small"
                            options={companies?.map(company => {
                                return {
                                    label: (
                                        <>
                                            <Row>
                                                <Col
                                                    flex="60px"
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'flex-end',
                                                    }}
                                                >
                                                    <Tag color={stl(company?.code)}>{company?.code}</Tag>
                                                </Col>
                                                <Col flex="auto" style={{}}>
                                                    {company?.name}
                                                </Col>
                                            </Row>
                                        </>
                                    ),
                                    searchBy: `${company?.code} ${company?.name}`,
                                    value: company?.code,
                                    _id: company?._id,
                                };
                            })}
                            optionFilterProp="searchBy"
                            listItemHeight={10}
                            listHeight={550}
                            maxTagCount={1}
                            maxTagTextLength={10}
                            onChange={value => {
                                setSelectedCompanies(value);
                                setSelectedOrders('');
                                OnChangePaginator(1, pageSize);
                            }}
                            onClear={() => setSelectedCompanies('')}
                            showSearch
                        // value={selectedData}
                        />
                    </div>
                </div>
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.5rem',
                    }}
                >
                    <h5>Order: </h5>
                    <div>
                        <Select
                            loading={isFetchingcompanies}
                            mode="single"
                            allowClear
                            className={style.select}
                            placeholder={'Select Order'}
                            dropdownMatchSelectWidth={false}
                            dropdownStyle={{ minWidth: '350px' }}
                            style={{
                                minWidth: 350,
                            }}
                            size="small"
                            // onDeselect={onDeselect}
                            // onSelect={onSelect}
                            options={ordersList?.map(order => {
                                return {
                                    label: (
                                        <>
                                            <Row>
                                                <Col
                                                    flex="60px"
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'flex-end',
                                                    }}
                                                >
                                                    <Tag color={stl(order?.companyCode)}>{order?.companyCode}</Tag>
                                                </Col>
                                                <Col flex="auto" style={{}}>
                                                    {order?.name}
                                                </Col>
                                            </Row>
                                        </>
                                    ),
                                    searchBy: `[${order?.companyCode}] : ${order?.name}`,
                                    value: order?._id,
                                };
                            })}
                            value={selectedOrders}
                            optionFilterProp="searchBy"
                            listItemHeight={10}
                            listHeight={550}
                            maxTagCount={1}
                            maxTagTextLength={10}
                            onChange={value => {
                                setSelectedOrders(value);
                                OnChangePaginator(1, pageSize);
                                console.log(value);
                            }}
                            onClear={() => setSelectedOrders('')}
                            showSearch
                        />{' '}
                    </div>
                </div>
                <PopconfirmFilter
                    description={
                        <div className="d-flex skus_header_filter">
                            <Form
                                size="small"
                                labelCol={{
                                    span: 12,
                                }}
                                wrapperCol={{
                                    span: 14,
                                }}
                            >
                                <Form.Item label="CC Required:" size="small">
                                    <Select
                                        mode="single"
                                        allowClear
                                        className={style.select}
                                        placeholder="Is CC required?"
                                        style={{
                                            width: '180px',
                                        }}
                                        options={[
                                            { label: 'Yes', value: true },
                                            { label: 'No', value: false },
                                            { label: 'Undeclared', value: 'null' },
                                        ]}
                                        size="small"
                                        value={isCCRequired}
                                        onChange={e => {
                                            setisCCRequired(e);
                                        }}
                                    />
                                </Form.Item>
                                <Form.Item label="DD Approved:">
                                    <Select
                                        mode="single"
                                        allowClear
                                        className={style.select}
                                        placeholder="Is DD Approved?"
                                        style={{
                                            width: '180px',
                                        }}
                                        options={[
                                            { label: 'Yes', value: true },
                                            { label: 'No', value: false },
                                        ]}
                                        size="small"
                                        value={isDDApproved}
                                        onChange={e => {
                                            setIsDDApproved(e);
                                        }}
                                    />
                                </Form.Item>
                                <Form.Item label="Pending At RawQc:">
                                    <Select
                                        mode="single"
                                        allowClear
                                        className={style.select}
                                        placeholder="Is RawQc Pending?"
                                        style={{
                                            width: '180px',
                                        }}
                                        options={[
                                            { label: 'Yes', value: true },
                                            { label: 'No', value: false },
                                        ]}
                                        size="small"
                                        value={isPendingAtRawQC}
                                        onChange={e => {
                                            setIsPendingAtRawQc(e);
                                        }}
                                    />
                                </Form.Item>
                                <Form.Item label="Marked As Support:">
                                    <Select
                                        mode="single"
                                        allowClear
                                        className={style.select}
                                        placeholder="Is Marked As Support?"
                                        style={{
                                            width: '180px',
                                        }}
                                        options={[
                                            { label: 'Yes', value: true },
                                            { label: 'No', value: false },
                                        ]}
                                        size="small"
                                        value={markedAsSupport}
                                        onChange={e => {
                                            setMarkedAsSupport(e);
                                        }}
                                    />
                                </Form.Item>
                                <Form.Item label="Is Outbound">
                                    <Select
                                        mode="single"
                                        allowClear
                                        className={style.select}
                                        placeholder="Is Outbounded?"
                                        style={{
                                            width: '180px',
                                        }}
                                        options={[
                                            { label: 'Yes', value: true },
                                            { label: 'No', value: false },
                                        ]}
                                        size="small"
                                        value={isOutbound}
                                        onChange={e => {
                                            setIsOutbounded(e);
                                        }}
                                    />
                                </Form.Item>
                                <Form.Item label="Is Special Category">
                                    <Switch checked={isSpecialCategory} onChange={() => handleSpecialCategoryFilter()} />
                                </Form.Item>
                            </Form>
                        </div>
                    }
                    appliedFiltersCount={getFiltersAppliedCount()}
                />
            </div>
            <div className="d-flex reshoot-header">
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.5rem',
                    }}
                >
                    <div className={style.skuSearchField}>
                        <Input.TextArea
                            value={searchText}
                            allowClear
                            autoSize={{ minRows: 1, maxRows: 6 }}
                            placeholder="SKU / EAN, or paste a list"
                            size="small"
                            className={style.skuSearchInput}
                            onChange={e => {
                                setSearchText(e.target.value);
                                OnChangePaginator(1, pageSize);
                            }}
                            onPaste={e => {
                                const text = e.clipboardData?.getData('text') || '';
                                const next = parseSkuSearchList(text);
                                if (next.terms.length < 2) return;
                                e.preventDefault();
                                setSearchText(next.terms.join('\n'));
                                OnChangePaginator(1, pageSize);
                            }}
                        />
                        {parsedSearch.terms.length > 1 ? (
                            <span className={style.skuSearchHint}>
                                {parsedSearch.terms.length} SKUs
                                {parsedSearch.truncated ? ` (first ${MAX_SKU_SEARCH_TERMS})` : ''}
                            </span>
                        ) : null}
                    </div>
                </div>

                <div>
                    <Button
                        type="primary"
                        size="small"
                        disabled={!selectedRowKeys.length}
                        onClick={() => {
                            const skus = selectedRowKeys.map(id => selectedRowsById[id]).filter(Boolean);
                            if (!skus.length) return;
                            setBulkRaiseSkus(skus);
                            setRaisedRequestButtonData(skus[0]);
                            setIsRaiseRequestClicked(true);
                        }}
                    >
                        Raise Request{selectedRowKeys.length ? ` (${selectedRowKeys.length})` : ''}
                    </Button>
                </div>
                <div>
                    <Tooltip title={!selectedCompanies ? 'Select the client to export' : ''}>
                        <Button type="primary" size="small" onClick={() => downloadExcelFile()} disabled={!selectedCompanies}>
                            Export Data
                        </Button>
                    </Tooltip>
                </div>
                <div className="">
                    <Button type="primary" onClick={ClearAllFilters} size="small">
                        Reset Filters
                    </Button>
                </div>
            </div>
            <PaginatedTable
                height={`calc(100vh - 170px)`}
                Footer={null}
                OnChangePaginator={OnChangePaginator}
                rowKey="_id"
                pageSizeOptions={[20, 50, 100, 200, 500, 1000]}
                rowSelection={{
                    selectedRowKeys,
                    onChange: (keys, rows) => {
                        setSelectedRowKeys(keys);
                        setSelectedRowsById(prev => {
                            const next = {};
                            keys.forEach(id => {
                                next[id] = rows.find(row => row._id === id) || prev[id];
                            });
                            return next;
                        });
                    },
                    getCheckboxProps: record => ({
                        disabled: !!record?.openRequests?.length,
                    }),
                }}
                rowClassName={record => (record?.tentativeShootDone ? style.tentativeShootDoneRow : '')}
                columns={[
                    {
                        title: 'SkuName',
                        key: 'skuName',
                        sorter: (a, b) => cmpText(skuDisplayName(a), skuDisplayName(b)),
                        render: (_, record) => {
                            return (
                                <>
                                    <div>{skuDisplayName(record)}</div>
                                    {record?.tentativeShootDone && (
                                        <Tag color="red" style={{ marginTop: 4 }}>
                                            Tentative Shoot Done
                                        </Tag>
                                    )}
                                </>
                            );
                        },
                    },
                    {
                        title: 'Company',
                        key: 'company',
                        sorter: (a, b) => cmpText(a?.article?.companyCode, b?.article?.companyCode),
                        render: (_, record) => {
                            return (
                                <>
                                    <div>{record?.article?.companyCode}</div>
                                </>
                            );
                        },
                    },
                    {
                        title: 'Order Name',
                        key: 'orderName',
                        sorter: (a, b) => cmpText(a?.article?.orderName, b?.article?.orderName),
                        render: (_, record) => {
                            return (
                                <>
                                    <div>{record?.article?.orderName}</div>
                                </>
                            );
                        },
                    },
                    {
                        title: 'Model',
                        key: 'modelName',
                        width: '8%',
                        sorter: (a, b) => cmpText(a?.model?.name, b?.model?.name),
                        render: (_, record) => {
                            return (
                                <div>
                                    <div>{record?.model?.name}</div>
                                    <div>{record?.model?.occassion ? '(' + record?.model?.occassion + ')' : ''}</div>
                                </div>
                            );
                        },
                    },
                    {
                        title: 'Shoot Complete',
                        key: 'isRawQCCompleted',
                        sorter: (a, b) => cmpBool(a?.isRawQCComplete, b?.isRawQCComplete),
                        render: (_, record) => {
                            return (
                                <>
                                    <div>{record?.markedAsSupport || record?.isOutbound ? '-' : record?.isRawQCComplete ? 'Yes' : 'No'}</div>
                                </>
                            );
                        },
                    },
                    {
                        title: 'Pending At RAW QC',
                        key: 'isPendingAtRawQC',
                        sorter: (a, b) => cmpBool(a?.isPendingAtRawQC, b?.isPendingAtRawQC),
                        render: (_, record) => {
                            return (
                                <>
                                    <div>{record?.markedAsSupport || record?.isOutbound ? '-' : record?.isPendingAtRawQC ? 'Yes' : 'No'}</div>
                                </>
                            );
                        },
                    },
                    {
                        title: 'Marked As Support',
                        key: 'markedAsSupport',
                        sorter: (a, b) => cmpBool(a?.markedAsSupport, b?.markedAsSupport),
                        render: (_, record) => {
                            return (
                                <>
                                    <div>{record?.markedAsSupport ? 'Yes' : 'No'}</div>
                                </>
                            );
                        },
                    },
                    {
                        title: 'Pending Shoot Types',
                        key: 'pendingShootTypes',
                        sorter: (a, b) => cmpText(a?.pendingShootTypes, b?.pendingShootTypes),
                        render: (_, record) => {
                            return (
                                <>
                                    <div>{record?.markedAsSupport || record?.isOutbound ? '-' : record?.pendingShootTypes || '-'}</div>
                                </>
                            );
                        },
                    },
                    {
                        title: 'ProductionStatus',
                        key: 'status',
                        children: [
                            {
                                title: 'PrincipalProduction',
                                key: 'PrincipalProduction',
                                sorter: (a, b) =>
                                    cmpBool(a?.postProductionStatus?.PrincipalProduction, b?.postProductionStatus?.PrincipalProduction),
                                render: (_, record) => {
                                    return (
                                        <>
                                            {record?.postProductionStatus?.PrincipalProduction ? (
                                                <CheckCircleOutlined style={{ color: 'lightgreen' }} />
                                            ) : (
                                                <CloseOutlined style={{ color: 'red' }} />
                                            )}
                                        </>
                                    );
                                },
                            },
                            {
                                title: 'PrincipalClientQC',
                                key: 'PrincipalClientQC',
                                sorter: (a, b) =>
                                    cmpBool(a?.postProductionStatus?.PrincipalClientQC, b?.postProductionStatus?.PrincipalClientQC),
                                render: (_, record) => {
                                    return (
                                        <>
                                            {record?.postProductionStatus?.PrincipalClientQC ? (
                                                <CheckCircleOutlined style={{ color: 'lightgreen' }} />
                                            ) : (
                                                <CloseOutlined style={{ color: 'red' }} />
                                            )}
                                        </>
                                    );
                                },
                            },
                            {
                                title: 'PrincipalDelivery',
                                key: 'PrincipalDelivery',
                                sorter: (a, b) =>
                                    cmpBool(a?.postProductionStatus?.PrincipalDelivery, b?.postProductionStatus?.PrincipalDelivery),
                                render: (_, record) => {
                                    return (
                                        <>
                                            {record?.postProductionStatus?.PrincipalDelivery ? (
                                                <CheckCircleOutlined style={{ color: 'lightgreen' }} />
                                            ) : (
                                                <CloseOutlined style={{ color: 'red' }} />
                                            )}
                                        </>
                                    );
                                },
                            },
                        ],
                    },
                    {
                        title: 'Action',
                        key: 'action',
                        render: (_, record) => {
                            return (
                                <>
                                    <div
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                        }}
                                    >
                                        <Button
                                            type="primary"
                                            onClick={() => {
                                                setBulkRaiseSkus([]);
                                                setIsRaiseRequestClicked(true);
                                                setRaisedRequestButtonData(record);
                                            }}
                                            style={{ margin: '0 5px' }}
                                            disabled={!!record?.openRequests?.length}
                                        >
                                            Raise Request
                                        </Button>
                                        <Button
                                            onClick={() => {
                                                setShowSkuDetails(true);
                                                setSelectedSku(record);
                                            }}
                                        // disabled={!!record?.openRequests?.length || record?.isDDApproved == false}
                                        >
                                            <EyeTwoTone />
                                        </Button>
                                    </div>
                                </>
                            );
                        },
                    },
                ]}
                dataSource={skuList?.data}
                isFetching={isFetchingSkus}
                total={skuList?.total}
                defaultPageSize={20}
                key={'skuTable'}
                pageNum={pageNum}
                pageSize={pageSize}
            />
            {!!selectedSku && !!showSkuDetails && (
                <SkuDetails
                    onCancel={() => {
                        setSelectedSku(null);
                        setShowSkuDetails(false);
                    }}
                    open={showSkuDetails}
                    skuId={selectedSku?._id}
                    selectedSKU={selectedSku}
                />
            )}
            {isRaiseRequestClicked && (
                <DynamicModal
                    open={isRaiseRequestClicked}
                    closable={true}
                    width={['Reshoot', 'Preset Change'].includes(selelctedRequestType) ? '70%' : undefined}
                    title={
                        <ModalTitle
                            name={
                                bulkRaiseSkus.length > 1
                                    ? `${bulkRaiseSkus.length} SKUs`
                                    : `${raisedRequestButtonData?.csvData?.EAN || raisedRequestButtonData?.csvData?.barcode || raisedRequestButtonData?.skuName
                                    }`
                            }
                            batchName={raisedRequestButtonData?.article?.orderName}
                            companyCode={raisedRequestButtonData?.article?.companyCode}
                            barcodes={raisedRequestButtonData?.barcodes}
                        />
                        // [<div className="" style={{ display: 'flex', justifyContent: 'flex-start' }}></div>]
                        // `${raisedRequestButtonData?.skuName} - Raise ${selelctedRequestType} Request `
                    }
                    close={() => resetRaiseForm()}
                    component={
                        <RaiseRequests
                            selelctedRequestType={selelctedRequestType}
                            setSelectedRequestType={setSelectedRequestType}
                            raisedRequestButtonData={raisedRequestButtonData}
                            getReshootCategoriesOption={getReshootCategoriesOption}
                            selectedCategoryForReshoot={selectedCategoryForReshoot}
                            setSelectedCategoryForReshoot={setSelectedCategoryForReshoot}
                            setWantNewCategoryToAdd={setWantNewCategoryToAdd}
                            wantNewCategoryToAdd={wantNewCategoryToAdd}
                            newCategoryAdded={newCategoryAdded}
                            setNewCategoryAdded={setNewCategoryAdded}
                            addNewCategoryToList={addNewCategoryToList}
                            requestComment={requestComment}
                            setRequestComment={setRequestComment}
                            closeDamageRequest={() => resetRaiseForm()}
                            raiseRequestConfirm={() => raiseConfirmRequest()}
                            bulkSkus={bulkRaiseSkus}
                            confirmLoading={isRaisingRequests}
                            handleAngleSelection={handleAngleSelection}
                            selectedAngles={selectedAngles}
                            handleSelectAllAngles={handleSelectAllAngles}
                            isPresetChangeReshootRequired={isPresetChangeReshootRequired}
                            setPresetChangeReshootRequired={setPresetChangeReshootRequired}
                            selectedPresetId={selectedPresetId}
                            setSelectedPresetId={setSelectedPresetId}
                            selectedModel={selectedModel}
                            setSelectedModel={setSelectedModel}
                            isAutoApproveDD={isAutoApproveDD}
                            setAutoApproveDD={setAutoApproveDD}
                            autoApproveRequest={autoApproveRequest}
                            setAutoApproveRequest={setAutoApproveRequest}
                            targetCompanyCode={targetCompanyCode}
                            setTargetCompanyCode={setTargetCompanyCode}
                            targetOrderId={targetOrderId}
                            setTargetOrderId={setTargetOrderId}
                        />
                    }
                />
            )}
        </>
    );
}
